import { render, staticRenderFns } from "./ProcessExceptionsList.vue?vue&type=template&id=2039dbe4&"
import script from "./ProcessExceptionsList.vue?vue&type=script&lang=js&"
export * from "./ProcessExceptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports